(function () {
  if (!window.location.pathname.includes("/a/")) {
    return; // 🚫 Not the subscriptions page
  }

  // Dynamically classify Skio modals so CSS can target specific calendar behavior
  function classifySkioModals() {
    // Use precise Skio modal classes instead of generic fallbacks
    const modals = document.querySelectorAll(".SubscriptionModal, .MuiModal-root[role='presentation']");
    
    modals.forEach((modal) => {
      // Find the exact title of the modal (usually the first h2 or Typography element) to prevent false matches
      const titleEl = modal.querySelector("h2, .MuiTypography-h6");
      const text = titleEl ? (titleEl.textContent || "").toLowerCase().trim() : (modal.textContent || "").toLowerCase();

      // Exact word matching for the modal title
      if (text === "reactivate" || text.includes("reactivate")) {
        modal.classList.add("skio-modal-reactivate");
        modal.classList.remove("skio-modal-edit-frequency");
        modal.setAttribute("data-modal-type", "reactivate");
        injectDynamicCalendarIntoReactivate(modal);
      } else if (
        text === "edit frequency" ||
        text === "change delivery date" ||
        text === "next order" ||
        text === "billing date" ||
        text === "order frequency" ||
        text.includes("frequency")
      ) {
        modal.classList.add("skio-modal-edit-frequency");
        modal.classList.remove("skio-modal-reactivate");
        modal.setAttribute("data-modal-type", "edit-frequency");
      }
    });
  }
  // Get all date ISO strings (YYYY-MM-DD) for the current week (Monday through Sunday)
  function getCurrentWeekDates(refDateStr) {
    let today;
    if (refDateStr) {
      const parts = refDateStr.split("-").map(Number);
      today = new Date(parts[0], parts[1] - 1, parts[2]);
    } else {
      const now = new Date();
      today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    }

    const dow = today.getDay(); // 0 = Sun, 1 = Mon ... 6 = Sat
    const daysSinceMonday = (dow + 6) % 7;
    const monday = new Date(today.getFullYear(), today.getMonth(), today.getDate() - daysSinceMonday);

    const dates = [];
    for (let i = 0; i < 7; i++) {
      const d = new Date(monday.getFullYear(), monday.getMonth(), monday.getDate() + i);
      const y = d.getFullYear();
      const m = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      dates.push(`${y}-${m}-${day}`);
    }
    return dates;
  }

  // Inject the custom dynamic calendar into the Reactivate modal and bridge it to Skio's state
  function injectDynamicCalendarIntoReactivate(modal, attempts = 0) {
    if (!modal || !modal.isConnected) return;
    if (modal.querySelector(".binaery-reactivate-wrapper")) return;
    if (!window.BinaeryCalendar) return;

    // React components may render .rdp slightly after the modal wrapper is mounted
    const rdp = modal.querySelector(".rdp");
    if (!rdp) {
        if (attempts > 20) return; // Prevent unbounded polling if .rdp never mounts (max 1s)
        setTimeout(() => injectDynamicCalendarIntoReactivate(modal, attempts + 1), 50);
        return;
    }

    const wrapper = document.createElement("div");
    wrapper.className = "binaery-reactivate-wrapper binaery-modal-calendar";
    wrapper.innerHTML = `
      <div class="binaery-calendar" data-binaery-role="calendar-host">
        <div class="binaery-calendar-header">
          <button type="button" class="binaery-calendar-nav" data-binaery-role="prev" aria-label="Previous month">‹</button>
          <div class="binaery-calendar-month" data-binaery-role="month-label"></div>
          <button type="button" class="binaery-calendar-nav" data-binaery-role="next" aria-label="Next month">›</button>
        </div>
        <div class="binaery-calendar-weekdays" data-binaery-role="weekday-row">
          <div class="binaery-calendar-weekday"></div><div class="binaery-calendar-weekday"></div><div class="binaery-calendar-weekday"></div>
          <div class="binaery-calendar-weekday"></div><div class="binaery-calendar-weekday"></div><div class="binaery-calendar-weekday"></div>
          <div class="binaery-calendar-weekday"></div>
        </div>
        <div class="binaery-calendar-grid" data-binaery-role="day-grid">
          ${Array(42).fill(0).map((_, i) => `<button type="button" class="binaery-calendar-cell" data-day-index="${i}"></button>`).join('')}
        </div>
      </div>
    `;

    rdp.parentNode.insertBefore(wrapper, rdp);

    const baseRules = window.BinaeryRulesData || { disabledWeekdays: [0, 1, 2, 6], disabledDates: [], disabledRanges: [] };
    const cfg = { firstDay: 1 };

    // Reactivate Calendar Specific Condition: Disable all dates in the current week (e.g. 29, 30)
    const currentWeekDates = getCurrentWeekDates(window.ukToday);
    const existingDisabled = Array.isArray(baseRules.disabledDates) ? baseRules.disabledDates.slice() : [];
    const disabledDates = Array.from(new Set(existingDisabled.concat(currentWeekDates)));
    const existingRanges = Array.isArray(baseRules.disabledRanges) ? baseRules.disabledRanges.slice() : [];
    const disabledRanges = existingRanges.concat([{
      start: currentWeekDates[0],
      end: currentWeekDates[currentWeekDates.length - 1]
    }]);
    const specialEnabled = (baseRules.specialEnabledDates || []).filter(
      (d) => !currentWeekDates.includes(d)
    );

    const reactivateRules = Object.assign({}, baseRules, {
      isSkioPortal: true,
      disabledDates: disabledDates,
      disabledRanges: disabledRanges,
      specialEnabledDates: specialEnabled
    });

    // Prevent accidental clicks on the inline wrapper from triggering overlay dismiss or removeChild errors
    wrapper.addEventListener("click", function (e) {
      if (e.target === wrapper) {
        e.stopPropagation();
      }
    }, true);

    // Initialize our dynamic calendar inside the wrapper
    window.BinaeryCalendar.initOverlay(wrapper, cfg, reactivateRules);
    // Listen for attribute changes on the calendar host to detect when a user clicks a date
    const host = wrapper.querySelector("[data-binaery-role='calendar-host']");
    if (host) {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === "data-selected-iso") {
            const iso = host.getAttribute("data-selected-iso");
            if (iso) {
              syncIsoToRdp(iso, modal);
            }
          }
        });
      });
      observer.observe(host, { attributes: true });

      function showReactivateLoading() {
        let overlay = document.getElementById("binaery-portal-loading-overlay");
        if (!overlay) {
          overlay = document.createElement("div");
          overlay.id = "binaery-portal-loading-overlay";
          overlay.setAttribute("role", "status");
          overlay.setAttribute("aria-live", "polite");
          overlay.style =
            "position:fixed; inset:0; background:rgba(255,255,255,0.7); z-index:2147483647; display:flex; flex-direction:column; align-items:center; justify-content:center; gap:12px; backdrop-filter:blur(2px);";
          overlay.innerHTML =
            '<div style="width:40px; height:40px; border:4px solid #f3f3f3; border-top:4px solid #000; border-radius:50%; animation: binaery-spin 1s linear infinite;"></div>' +
            '<span style="font-family:inherit; font-size:14px; font-weight:500; color:#111827;">Reactivating your subscription…</span>' +
            '<style>@keyframes binaery-spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }</style>';
          document.body.appendChild(overlay);
        }
        overlay.style.display = "flex";
      }

      // Guard against duplicate registration on the same long-lived modal node
      if (!modal.__binaeryReloadListenerAttached) {
        modal.__binaeryReloadListenerAttached = true;
        const controller = new AbortController();
        let reloadTriggered = false;

        window.addEventListener(
          "pagehide",
          () => {
            controller.abort();
            modal.__binaeryReloadListenerAttached = false;
          },
          { once: true }
        );

        modal.addEventListener(
          "click",
          function (e) {
            try {
              if (reloadTriggered) return;

              const btn = e.target.closest(
                "button, [role='button'], input[type='submit'], .MuiButton-root"
              );
              if (!btn) return;

              if (btn.closest(".binaery-reactivate-wrapper") || btn.closest(".rdp")) return;
              if (btn.disabled || btn.getAttribute("aria-disabled") === "true") return;

              const btnText = (btn.textContent || "").trim().toLowerCase();
              const ariaLabel = (btn.getAttribute("aria-label") || "").toLowerCase();

              const isConfirmBtn =
                btnText.includes("confirm") ||
                btnText.includes("reactivate") ||
                ariaLabel.includes("confirm") ||
                ariaLabel.includes("reactivate");

              if (isConfirmBtn) {
                // Always read host from the live DOM because React re-renders can replace the wrapper
                const liveHost = modal.querySelector(
                  ".binaery-reactivate-wrapper [data-binaery-role='calendar-host']"
                );
                const datePicked = Boolean(liveHost && liveHost.dataset.selectedIso);

                if (datePicked) {
                  reloadTriggered = true;
                  showReactivateLoading();

                  let obs;
                  const reloadTimer = setTimeout(function () {
                    if (obs) obs.disconnect();
                    if ("scrollRestoration" in history) {
                      history.scrollRestoration = "manual";
                    }
                    window.scrollTo(0, 0);
                    window.location.reload();
                  }, 10000);

                  obs = new MutationObserver(() => {
                    if (modal.querySelector(".Mui-error, [role='alert']")) {
                      clearTimeout(reloadTimer);
                      obs.disconnect();
                      reloadTriggered = false;
                      const overlay = document.getElementById("binaery-portal-loading-overlay");
                      if (overlay) overlay.style.display = "none";
                    }
                  });

                  obs.observe(modal, { childList: true, subtree: true });
                }
              }
            } catch (err) {
              console.error("[Binaery]: reactivate click handler error", err);
            }
          },
          { capture: true, signal: controller.signal }
        );
      }
    }
  }

  function syncIsoToRdp(iso, modal) {
    const parts = String(iso).slice(0, 10).split("-").map(Number);
    const tY = parts[0];
    const tM = parts[1] - 1;
    const tD = parts[2];

    function tryClick(attempts = 0) {
        if (attempts > 10) return; // Prevent infinite loops
        
        // ALWAYS dynamically query the rdp container as React frequently re-renders and destroys old DOM nodes
        const rdpContainer = modal.querySelector(".rdp");
        if (!rdpContainer) {
            setTimeout(() => tryClick(attempts + 1), 50);
            return;
        }

        const caption = rdpContainer.querySelector(".rdp-caption_label");
        if (!caption) return;
        
        // Extract month and year from caption (e.g. "October 2026")
        const captionText = caption.textContent.replace(/[^a-zA-Z0-9\s]/g, "").trim();
        const rdpDate = new Date(captionText);
        if (isNaN(rdpDate.getTime())) return;
        
        const rM = rdpDate.getMonth();
        const rY = rdpDate.getFullYear();

        if (rY === tY && rM === tM) {
            // We are in the right month, click the matching day
            const days = rdpContainer.querySelectorAll(".rdp-day:not(.rdp-day_outside)");
            for (let i = 0; i < days.length; i++) {
                if (parseInt(days[i].textContent, 10) === tD) {
                    const btn = days[i];
                    
                    // Prevent deselecting: if Skio's calendar already has this date selected, do not click it again.
                    // (react-day-picker toggles selection off if you click an already-selected date).
                    if (btn.getAttribute("aria-selected") === "true" || btn.classList.contains("rdp-day_selected")) {
                        return;
                    }

                    // Dispatch both a native click and React-compatible pointer events
                    btn.click();
                    btn.dispatchEvent(new MouseEvent('mousedown', { bubbles: true, cancelable: true, view: window }));
                    btn.dispatchEvent(new MouseEvent('mouseup', { bubbles: true, cancelable: true, view: window }));
                    return;
                }
            }
        } else {
            // Navigate the hidden .rdp calendar to the target month
            const isFuture = (tY > rY) || (tY === rY && tM > rM);
            const navBtn = isFuture ? rdpContainer.querySelector(".rdp-nav_button_next") : rdpContainer.querySelector(".rdp-nav_button_previous");
            if (navBtn && !navBtn.disabled) {
                navBtn.click();
                // Wait for React to re-render the calendar before trying again
                setTimeout(() => tryClick(attempts + 1), 50);
            }
        }
    }
    tryClick();
  }

  // 🚫 Automatically hide "8 week" / "8 weeks" options in Skio Portal dropdowns & modals
  function hide8WeekOptions() {
    const options = document.querySelectorAll("option");
    options.forEach((opt) => {
      // Don't remove options inside Reactivate modals
      if (opt.closest(".skio-modal-reactivate, [data-modal-type='reactivate']")) return;

      const val = (opt.value || "").toLowerCase();
      const txt = (opt.textContent || "").toLowerCase();
      // Skip removal if option is currently selected to preserve existing 8-week subscriber state
      if ((val.includes("8 week") || txt.includes("8 week")) && !opt.selected) {
        opt.remove();
      }
    });
  }

  const selector = ".SubscriptionGroup-Active";
  let bannerInjectedOrPending = false;                                                                                                              

  // Initial execution
  classifySkioModals();
  hide8WeekOptions();

  const existing = document.querySelector(selector);
  if (existing && !document.querySelector(".custom-subscription-info") && !bannerInjectedOrPending) {
    runLogic(existing);
  }

  const observer = new MutationObserver(() => {
    try {
      classifySkioModals();
      hide8WeekOptions();

      const el = document.querySelector(selector);
      if (el && !document.querySelector(".custom-subscription-info") && !bannerInjectedOrPending) {
        runLogic(el);
      }
    } catch (err) {
      console.error("[EQ Debug]: Subscription observer error", err);
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  // Safety net: disconnect observer on page unload/teardown
  window.addEventListener("pagehide", () => observer.disconnect());

  function runLogic(element) {
    if (document.querySelector(".custom-subscription-info") || bannerInjectedOrPending) {
      return; // 🚫 Banner already present or fetch in-flight
    }
    bannerInjectedOrPending = true;

    //debugger;
    let customerInformation = getLatestSkioUserEmail({ clean: true });
    let customerEmailID = null;
    if (customerInformation != null) {
      customerEmailID = customerInformation.value.split("-skioSiteId-")[0];
    }
    /*
    console.log(`[EQ Debug]: Customer Email ID found`, customerEmailID);
    console.log(`[EQ Debug]: Customer Information found`, customerInformation);
    */
    function attachBanner(targetElement, infoDiv) {
      if (!targetElement) {
        console.log("[EQ Debug]: targetElement not found");
        return;
      }

      if (targetElement.parentNode) {
        targetElement.parentNode.insertBefore(infoDiv, targetElement);
      } else {
        targetElement.prepend(infoDiv);
      }
    }

    if (customerEmailID == null) {
      let textContentToAdd = `⚠️ Warning: Anything you change below won't affect orders that have already been paid for. If you're looking to make changes, reach out to us on <a href="mailto:team@stockedfood.com">email</a> or <a href="https://wa.me/447942333689">WhatsApp</a>!`;
      const infoDiv = document.createElement("div");
      infoDiv.className = "custom-subscription-info";
      infoDiv.innerHTML = `

        <div style="">
          ${textContentToAdd}
        </div>
      `;
      attachBanner(element, infoDiv);
      console.log(
        `[EQ Debug]: Found element for subscriptions page`,
        element
      );
    } else {
      const requestOptions = {
        method: "GET",
        redirect: "follow",
      };
      fetch(
        `https://stockedfood.eqserver.net/order/graphql/customer/last5/by-email/${customerEmailID}`,
        requestOptions
      )
        .then((response) => response.text())
        .then((result) => {
          const latestOrder = JSON.parse(result)?.orders?.[0];
          console.log(latestOrder?.processedAt);
          console.log(latestOrder?.tags);
          let tags = null;
          let orderPaymentDate = latestOrder?.processedAt;
          tags = latestOrder?.tags;
          let dateOfDelivery = extractDateFromTags(tags);
          let dateOfDeliveryFormatted = null;
          if (dateOfDelivery != null) {
            dateOfDeliveryFormatted = formatDDMMYYYYToReadable(dateOfDelivery);
            console.log(
              `[EQ Debug]: Date of delivery extracted from tags: ${dateOfDeliveryFormatted}`
            );
          }
          let formattedDate = new Date(orderPaymentDate).toLocaleDateString(
            "en-GB",
            {
              day: "2-digit",
              month: "long",
              year: "numeric",
            }
          );

          let deliveryTextContentToAdd = ``;
          let textContentToAdd = ``;
          if (dateOfDelivery != null) {
            deliveryTextContentToAdd = ` for <b>delivery on ${dateOfDeliveryFormatted}</b>`;
            let todayDate = new Date();
            let deliveryDateObj = new Date(dateOfDeliveryFormatted);
            if (deliveryDateObj > todayDate) {
              textContentToAdd = `⚠️ Warning: you have an order that has been paid for on <b>${formattedDate}</b>${deliveryTextContentToAdd}. Anything you change below won't affect this order so if you're looking to make changes, reach out to us on <a href="mailto:team@stockedfood.com">email</a> or <a href="https://wa.me/447942333689">WhatsApp</a>!`;
            } else {
              textContentToAdd = `⚠️ Warning: Anything you change below won't affect orders that have already been paid for. If you're looking to make changes, reach out to us on <a href="mailto:team@stockedfood.com">email</a> or <a href="https://wa.me/447942333689">WhatsApp</a>!`;
            }
          } else {
            textContentToAdd = `⚠️ Warning: Anything you change below won't affect orders that have already been paid for. If you're looking to make changes, reach out to us on <a href="mailto:team@stockedfood.com">email</a> or <a href="https://wa.me/447942333689">WhatsApp</a>!`;
          }

          const infoDiv = document.createElement("div");
          infoDiv.className = "custom-subscription-info";
          infoDiv.innerHTML = `
            <div style="">
              ${textContentToAdd}
            </div>
          `;
          attachBanner(element, infoDiv);
        })
        .catch((error) => {
          // Don't reset bannerInjectedOrPending here: the observer would call runLogic again
          // on the next DOM mutation and re-fetch endlessly. Fall back to the default banner instead.
          console.error("[EQ Debug]: Last order fetch failed, showing default banner", error);
          if (document.querySelector(".custom-subscription-info")) return;
          const infoDiv = document.createElement("div");
          infoDiv.className = "custom-subscription-info";
          infoDiv.innerHTML = `
            <div style="">
              ⚠️ Warning: Anything you change below won't affect orders that have already been paid for. If you're looking to make changes, reach out to us on <a href="mailto:team@stockedfood.com">email</a> or <a href="https://wa.me/447942333689">WhatsApp</a>!
            </div>
          `;
          attachBanner(element, infoDiv);
        });
    }
    // 🔥 your actual logic here
  }
})();

const extractDateFromTags = (tags) => {
  if (!Array.isArray(tags)) return null;

  // Matches DD.MM.YYYY where year is between 2026–2030
  const dateRegex = /\b\d{1,2}\.\d{1,2}\.(2026|2027|2028|2029|2030)\b/;

  for (const tag of tags) {
    const match = tag.match(dateRegex);
    if (match) {
      return match[0];
    }
  }

  return null;
};

/**
 * Returns the latest email found inside UserAttributes in localStorage
 * @param {Object} options
 * @param {boolean} options.clean - remove "-skioSiteId-..." from email
 * @returns {{ key: string, value: string } | null}
 */
const getLatestSkioUserEmail = (options = { clean: false }) => {
  let lastEmail = null;

  for (let i = 0; i < localStorage.length; i++) {
    const storageKey = localStorage.key(i);
    const rawValue = localStorage.getItem(storageKey);

    if (typeof rawValue !== "string" || !rawValue.includes("UserAttributes")) {
      continue;
    }

    try {
      const parsed = JSON.parse(rawValue);
      const userAttributes = parsed?.UserAttributes;

      if (!Array.isArray(userAttributes)) continue;

      const emailObj = userAttributes.find(
        (attr) => attr?.Name === "email" && typeof attr.Value === "string"
      );

      if (emailObj) {
        lastEmail = {
          key: "email",
          value: options.clean
            ? emailObj.Value.split("-skioSiteId-")[0]
            : emailObj.Value,
        };
      }
    } catch (e) {
      // Ignore invalid JSON safely
    }
  }

  return lastEmail;
};

const formatDDMMYYYYToReadable = (dateStr) => {
  if (!dateStr) return null;

  const [day, month, year] = dateStr.split(".");
  if (!day || !month || !year) return null;

  const date = new Date(Date.UTC(year, month - 1, day));

  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "long",
    year: "numeric",
    timeZone: "UTC",
  });
};

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("video").forEach((video) => {
    if (video.paused && !video.ended) {
      video.muted = true;
      video.play().catch(() => {});
    }
  });
});

const babCache = {};
function getBabDocument(babUrl) {
  if (!babCache[babUrl]) {
    babCache[babUrl] = fetch(babUrl)
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch Bundle page");
        return res.text();
      })
      .then((html) => {
        const parser = new DOMParser();
        return parser.parseFromString(html, "text/html");
      })
      .catch((err) => {
        delete babCache[babUrl];
        throw err;
      });
  }
  return babCache[babUrl];
}

function findDishPickerContainers(root) {
  const itemsLabels = Array.from(root.querySelectorAll("span")).filter((s) =>
    /^Items\s*\(\d+\)$/.test(s.textContent.trim())
  );

  const containers = new Set();

  itemsLabels.forEach((label) => {
    let el = label;
    for (let i = 0; i < 8 && el; i++) {
      el = el.parentElement;
      if (!el) break;
      if (el.querySelectorAll("img").length >= 3) {
        containers.add(el);
        break;
      }
    }
  });

  return Array.from(containers);
}

function setupSkioModalInfoIcons(root) {
  const containers = findDishPickerContainers(root);

  containers.forEach((container) => {
    try {
      container.querySelectorAll("img").forEach((img) => {
        if (img.classList.contains("custom-info-added")) return;

        img.classList.add("custom-info-added");

        const imgContainer = img.parentElement;
        if (!imgContainer) return;

        imgContainer.classList.add("custom-skio-img-container");

        const infoBtn = document.createElement("button");
        infoBtn.type = "button";
        infoBtn.className = "info-icon-button custom-skio-info-btn";
        infoBtn.innerHTML = `
          <div class="button-bg"></div>
          <span>i</span>
        `;
        imgContainer.appendChild(infoBtn);

        const card =
          img.closest(
            "[class*='DishCard'], [class*='dish-card'], [class*='ProductCard'], [class*='product-card']"
          ) || img.parentElement?.parentElement?.parentElement;
        if (card) card.classList.add("custom-skio-dish-card");
      });
    } catch (err) {
      console.error("setupSkioModalInfoIcons error:", err);
    }
  });
}

function setupAddonInfoIcons(root) {
  root.querySelectorAll(".cart-template__addon-item").forEach((item) => {
    const trigger = item.querySelector(".cart-addon-image-trigger");
    if (!trigger || trigger.dataset.infoAdded) return;

    trigger.dataset.infoAdded = "true";
    trigger.classList.add("custom-skio-img-container");

    const infoBtn = document.createElement("button");
    infoBtn.type = "button";
    infoBtn.className = "info-icon-button custom-skio-info-btn";
    infoBtn.innerHTML = `
      <div class="button-bg"></div>
      <span>i</span>
    `;

    trigger.appendChild(infoBtn);
    item.classList.add("custom-skio-dish-card");
  });
}

// Debounced setup to avoid running too frequently
let skioSetupTimer = null;
function debouncedSetup() {
  clearTimeout(skioSetupTimer);
  skioSetupTimer = setTimeout(() => {
    setupSkioModalInfoIcons(document.body);
    setupAddonInfoIcons(document.body);
  }, 100);
}

// Persistent observer watches whole body for Skio portal injections
const skioModalObserver = new MutationObserver(debouncedSetup);
skioModalObserver.observe(document.body, {
  childList: true,
  subtree: true,
});

// Run once immediately
setupSkioModalInfoIcons(document.body);
setupAddonInfoIcons(document.body);
function handleDocumentClick(e) {
  try {
    const addonTrigger = e.target.closest(".cart-addon-image-trigger");
    if (addonTrigger && addonTrigger.dataset.handle) {
      e.preventDefault();
      e.stopPropagation();
      if (window.openStockedProductModal) {
        window.openStockedProductModal(
          addonTrigger.dataset.handle,
          true,
          addonTrigger
        );
      }
      return;
    }

    const infoBtn = e.target.closest(".custom-skio-info-btn");
    if (!infoBtn) return;

    e.preventDefault();
    e.stopPropagation();

    const imgContainer = infoBtn.parentElement;
    const image = imgContainer?.querySelector("img");
    if (!image) return;

    // Addon products
    const trigger = infoBtn.closest(".cart-addon-image-trigger");
    if (trigger?.dataset.handle) {
      window.openStockedProductModal(trigger.dataset.handle, true, trigger);
      return;
    }
    const title = image.alt?.trim();
    const handle = window.stockedActiveProductsMap?.[title];

    if (!handle) return;

    if (window.openStockedProductModal) {
      window.openStockedProductModal(handle, false, infoBtn);
    }
  } catch (err) {
    console.error("[DocumentClick] Error handling click:", err);
  }
}

// Remove previous listener if registered before adding a new one
if (typeof window._cleanupDocumentClick === "function") {
  window._cleanupDocumentClick();
}

document.addEventListener("click", handleDocumentClick);

// expose cleanup for callers
window._cleanupDocumentClick = function () {
  document.removeEventListener("click", handleDocumentClick);
};

window.openStockedProductModal = function (
  handle,
  isAddon = false,
  triggerElement = null
) {
  const url = `/products/${handle}`;

  // Create modal if it doesn't exist
  let modal = document.getElementById("custom-product-modal");
  if (!modal) {
    modal = document.createElement("div");
    modal.id = "custom-product-modal";

    const modalContent = document.createElement("div");
    modalContent.className = "custom-product-modal-content";

    const closeBtn = document.createElement("button");
    closeBtn.className = "custom-product-modal-close";
    closeBtn.innerHTML = "&times;";

    closeBtn.onclick = function () {
      modal.style.display = "none";
      const container = document.getElementById("custom-product-content");
      if (container) container.innerHTML = ""; // clear content to stop videos/scripts
      document.body.style.overflow = ""; // restore body scroll
    };

    const contentContainer = document.createElement("div");
    contentContainer.id = "custom-product-content";

    modalContent.appendChild(closeBtn);
    modalContent.appendChild(contentContainer);
    modal.appendChild(modalContent);
    document.body.appendChild(modal);

    // Close on click outside
    modal.addEventListener("click", function (event) {
      if (event.target === modal) {
        modal.style.display = "none";
        const container = document.getElementById("custom-product-content");
        if (container) container.innerHTML = "";
        document.body.style.overflow = "";
      }
    });
  }

  const contentContainer = document.getElementById("custom-product-content");
  modal.style.display = "flex";
  document.body.style.overflow = "hidden"; // Prevent background scrolling

  // Fetch HTML directly to bypass iframe CSP blocks
  fetch(url)
    .then((res) => {
      if (!res.ok) throw new Error("Product page not found");
      return res.text();
    })
    .then((html) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      const template = doc.querySelector(".product-template");

      // 1. First, see if the popup contents are directly on the fetched product page
      // (We recently added a hidden build-a-bundle-product-card to the main product template to support this)
      let directPopup = doc.querySelector(".product-popup-contents");

      if (directPopup) {
        return injectPopupContent(directPopup);
      }

      // 2. If not found directly, check if it's a bundle product and fetch from the bundle page
      if (template) {
        const babUrl = template.dataset.babUrl;
        const productId = template.dataset.productId;

        if (babUrl && productId) {
          return getBabDocument(babUrl).then((babDoc) => {
            const popupContent = babDoc.querySelector(
              `.product-popup-contents[data-product-id="${productId}"]`
            );
            if (popupContent) {
              injectPopupContent(popupContent);
            } else {
              throw new Error(
                "Product details snippet not found in Bundle page"
              );
            }
          });
        }
      }

      // 3. Fallback: render the whole product page content without header/footer if no popup available
      const mainContent =
        doc.querySelector("main") ||
        doc.querySelector("#smooth-content") ||
        doc.body;
      contentContainer.innerHTML = mainContent.innerHTML;

      function injectPopupContent(popupElement) {
        // Clone the popup content to avoid mutating cache
        const clone = popupElement.cloneNode(true);

        // Hide the Add to Bundle (ATB) container since we are on subscriptions page
        if (isAddon) {
          const defaultMobileBtn = clone.querySelector(
            ".bab-product-popup-contents__atb-container > .button.desktop\\:hidden"
          );
          if (defaultMobileBtn) defaultMobileBtn.style.display = "none";

          const subBtn = clone.querySelector(
            ".bab-product-popup-contents__atb-container .sub-btn"
          );
          if (subBtn) subBtn.style.display = "none";

          const otpBtn = clone.querySelector(
            ".bab-product-popup-contents__atb-container .otp-btn"
          );
          if (otpBtn) {
            otpBtn.classList.remove("hidden", "desktop:hidden");
            otpBtn.style.display = "flex"; // or block
          }
        }

        if (!isAddon) {
          const atbContainer = clone.querySelector(
            ".bab-product-popup-contents__atb-container"
          );
          if (atbContainer && atbContainer.parentElement) {
            atbContainer.parentElement.style.display = "none";
          }
        }

        // Inject the popup content
        contentContainer.innerHTML = clone.innerHTML;

        // Wire up functionality
        setupModalSwiper();
        setupModalVideos();
        setupModalAccordions();
        setupModalNutritionInfo();
        setupModalATB();
        setupModalReviewClick();

        // Trigger Judge.me render

        if (
          window.jdgmCacheServer &&
          typeof window.jdgmCacheServer.reloadAll === "function"
        ) {
          window.jdgmCacheServer.reloadAll();
        } else if (
          window.jdgmCacheServer &&
          typeof window.jdgmCacheServer.reload === "function"
        ) {
          window.jdgmCacheServer.reload();
        } else if (
          window.jdgm &&
          typeof window.jdgm.initializeWidgets === "function"
        ) {
          window.jdgm.initializeWidgets();
        }
      }
    })
    .catch((err) => {
      contentContainer.innerHTML =
        '<div class="custom-product-modal-error">Failed to load product details.</div>';
      console.error("Error fetching product popup:", err);
    });

  // Helper to initialize Swiper inside the modal if Swiper is available
  function setupModalSwiper() {
    const mainSwiperEl = contentContainer.querySelector(
      ".product-template__media-container__main-swiper .swiper"
    );
    const thumbsSwiperEl = contentContainer.querySelector(
      ".product-template__media-container__thumbs-swiper .swiper"
    );

    if (mainSwiperEl && thumbsSwiperEl && typeof Swiper !== "undefined") {
      const thumbSwiper = new Swiper(thumbsSwiperEl, {
        spaceBetween: 12,
        slidesPerView: 4,
        watchSlidesProgress: true,
        slideToClickedSlide: true,
      });

      const mainSwiper = new Swiper(mainSwiperEl, {
        spaceBetween: 12,
        slidesPerView: 1,
        thumbs: {
          swiper: thumbSwiper,
        },
      });

      mainSwiper.controller.control = thumbSwiper;
      mainSwiper.on("slideChange", () => {
        thumbSwiper.slideTo(mainSwiper.realIndex);
      });
    } else {
      // Fallback for when Swiper is not loaded (or fails to initialize)
      const mainSlides = contentContainer.querySelectorAll(
        ".product-template__media-container__main-swiper .swiper-slide"
      );
      const thumbSlides = contentContainer.querySelectorAll(
        ".product-template__media-container__thumbs-swiper .swiper-slide"
      );
      const thumbsWrapper = contentContainer.querySelector(
        ".product-template__media-container__thumbs-swiper .swiper-wrapper"
      );

      if (mainSlides.length > 0 && thumbSlides.length > 0) {
        // Style the swiper wrapper to lay out thumbnails horizontally
        if (thumbsWrapper) {
          thumbsWrapper.style.display = "flex";
          thumbsWrapper.style.gap = "12px";
          thumbsWrapper.style.flexWrap = "wrap";
          thumbsWrapper.style.width = "100%";
        }

        // Initialize display state for main slides
        mainSlides.forEach((slide, index) => {
          if (index === 0) {
            slide.style.display = "block";
            slide.style.position = "relative";
            slide.style.opacity = "1";
            slide.style.pointerEvents = "auto";
          } else {
            slide.style.display = "none";
            slide.style.position = "absolute";
            slide.style.opacity = "0";
            slide.style.pointerEvents = "none";
          }
        });

        // Initialize display state and click handlers for thumbnails
        thumbSlides.forEach((thumb, index) => {
          thumb.style.width = "72px";
          thumb.style.height = "72px";
          thumb.style.flexShrink = "0";
          thumb.style.position = "relative";
          thumb.style.cursor = "pointer";
          thumb.style.borderWidth = "2px";
          thumb.style.borderStyle = "solid";

          if (index === 0) {
            thumb.classList.add("swiper-slide-thumb-active");
            thumb.style.borderColor = "rgba(239, 125, 0, 0.60)"; // selected-orange-border
          } else {
            thumb.classList.remove("swiper-slide-thumb-active");
            thumb.style.borderColor = "rgba(35, 35, 35, 0.10)"; // primary-border
          }

          thumb.addEventListener("click", (event) => {
            event.preventDefault();

            // Switch active main slide
            mainSlides.forEach((slide, slideIndex) => {
              if (slideIndex === index) {
                slide.style.display = "block";
                slide.style.position = "relative";
                slide.style.opacity = "1";
                slide.style.pointerEvents = "auto";
              } else {
                slide.style.display = "none";
                slide.style.position = "absolute";
                slide.style.opacity = "0";
                slide.style.pointerEvents = "none";

                // Pause video on inactive slides if playing
                const video = slide.querySelector("video");
                if (video) {
                  video.pause();
                  video.classList.add("hidden");
                  const img = slide.querySelector(".media__image");
                  const icon = slide.querySelector(".media__icon");
                  if (img) img.classList.remove("hidden");
                  if (icon) icon.classList.remove("hidden");
                }
              }
            });

            // Update active thumbnail border
            thumbSlides.forEach((t, tIndex) => {
              if (tIndex === index) {
                t.classList.add("swiper-slide-thumb-active");
                t.style.borderColor = "rgba(239, 125, 0, 0.60)";
              } else {
                t.classList.remove("swiper-slide-thumb-active");
                t.style.borderColor = "rgba(35, 35, 35, 0.10)";
              }
            });
          });
        });
      } else {
        // Fallback: show only the first image and hide thumbs/rest if not enough slides
        const slides = contentContainer.querySelectorAll(
          ".product-template__media-container__main-swiper .swiper-slide"
        );
        slides.forEach((slide, index) => {
          if (index > 0) slide.style.display = "none";
        });
        const thumbs = contentContainer.querySelector(
          ".product-template__media-links"
        );
        if (thumbs) thumbs.style.display = "none";
      }
    }
  }

  // Helper to setup video clicks
  function setupModalVideos() {
    const mediaItems = contentContainer.querySelectorAll(
      ".product-template__media--video"
    );
    mediaItems.forEach((item) => {
      const img = item.querySelector(".media__image");
      const icon = item.querySelector(".media__icon");
      const video = item.querySelector(".media__video");
      if (img && icon && video) {
        img.addEventListener("click", (event) => {
          event.preventDefault();
          img.classList.add("hidden");
          icon.classList.add("hidden");
          video.classList.remove("hidden");
          video.play();
        });
        video.addEventListener("click", (event) => {
          event.preventDefault();
          video.pause();
          video.classList.add("hidden");
          img.classList.remove("hidden");
          icon.classList.remove("hidden");
        });
      }
    });
  }

  // Helper to setup accordion toggles
  function setupModalAccordions() {
    const containers = contentContainer.querySelectorAll(
      ".product-accordion-container"
    );
    containers.forEach((container) => {
      const accordions = container.querySelectorAll(".product-accordion");
      accordions.forEach((accordion) => {
        const trigger = accordion.querySelector(".product-accordion__trigger");
        const content = accordion.querySelector(".product-accordion__contents");
        if (trigger && content) {
          trigger.addEventListener("click", () => {
            if (accordion.classList.contains("active")) {
              accordion.classList.remove("active");
            } else {
              accordion.classList.add("active");
            }
          });
        }
      });
    });
  }

  // Helper to setup nutrition multiplier and toggle table
  function setupModalNutritionInfo() {
    const displays = contentContainer.querySelectorAll(
      ".product-nutrition-info-content"
    );
    displays.forEach((display) => {
      const optionsContainer = display.querySelector(
        ".product-nutrition-info-content__multiplier-container"
      );
      const nutritionValueContainers = display.querySelectorAll(
        ".product-nutrition-metric"
      );

      if (optionsContainer && nutritionValueContainers) {
        const multiplierOptions = optionsContainer.querySelectorAll(
          ".product-nutrition-info-content__multiplier-value"
        );
        multiplierOptions.forEach((multiplierOption) => {
          multiplierOption.addEventListener("click", (e) => {
            if (!multiplierOption.classList.contains("active")) {
              multiplierOptions.forEach((option) => {
                option.classList.remove("active");
              });
              multiplierOption.classList.add("active");

              const multiplier = parseInt(multiplierOption.textContent);
              if (multiplier) {
                nutritionValueContainers.forEach((valueContainer) => {
                  const originalValue = parseFloat(
                    valueContainer.dataset.originalValue
                  );
                  if (!isNaN(originalValue)) {
                    const metricSpan = valueContainer.querySelector(
                      ".product-nutrition-metric-value"
                    );
                    if (metricSpan) {
                      metricSpan.textContent =
                        Math.round(originalValue * multiplier * 100) / 100;
                    }
                  }
                });
              }
            }
          });
        });
      }

      // bind show/hide of nutrition table
      const nutritionTableCont = display.querySelector(
        ".nutrition-table-container"
      );
      if (nutritionTableCont) {
        const tableTrigger = nutritionTableCont.querySelector(
          ".nutrition-table-toggle"
        );
        const tableDropdown = nutritionTableCont.querySelector(
          ".nutrition-table-dropdown"
        );
        if (tableTrigger && tableDropdown) {
          const triggerChevron = tableTrigger.querySelector("svg");
          tableTrigger.addEventListener("click", (e) => {
            if (tableDropdown.classList.contains("hidden")) {
              tableDropdown.classList.remove("hidden");
              if (triggerChevron) {
                triggerChevron.classList.add("-rotate-180");
              }
            } else {
              tableDropdown.classList.add("hidden");
              if (triggerChevron) {
                triggerChevron.classList.remove("-rotate-180");
              }
            }
          });
        }
      }
    });
  }

  // Helper to handle clicking on the review badge in the modal
  function setupModalReviewClick() {
    const badge = contentContainer.querySelector(".pop-up-judgeme-badge");
    if (!badge) return;

    badge.style.cursor = "pointer";
    badge.addEventListener("click", (e) => {
      e.preventDefault();
      const reviewAccordion =
        contentContainer.querySelector(".review-accordion");
      if (reviewAccordion) {
        if (!reviewAccordion.classList.contains("active")) {
          reviewAccordion.classList.add("active");
        }
        reviewAccordion.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    });
  }

  function setupModalATB() {
    const atbContainer = contentContainer.querySelector(
      ".bab-product-popup-contents__atb-container"
    );
    if (!atbContainer) return;

    const infoText = atbContainer.parentElement?.querySelector(
      "span.text-grey-600.text-extra-small.font-brandon-text.justify-start"
    );

    if (infoText) {
      infoText.style.display = "none";
    }

    const increaseBtns = atbContainer.querySelectorAll(
      ".product-quantity__increase"
    );
    const decreaseBtns = atbContainer.querySelectorAll(
      ".product-quantity__decrease"
    );
    const qtyDisplays = atbContainer.querySelectorAll(".product-quantity");
    const atbButtons = atbContainer.querySelectorAll(
      ".bab-product-add-to-bundle"
    );

    const otpPriceDisplay = atbContainer.querySelector(
      ".otp-btn .product-price"
    );
    const subPriceDisplay = atbContainer.querySelector(
      ".sub-btn .product-price"
    );
    const subCompPriceDisplay = atbContainer.querySelector(
      ".sub-btn .product-comparison-price"
    );

    const singlePrice = parseFloat(atbContainer.dataset.singlePrice) || 0;
    const singleSubPrice =
      parseFloat(atbContainer.dataset.singleSubscriptionPrice) || 0;

    let currentQty = 1;

    function formatMoney(cents) {
      if (!cents) return "";
      let str = "£" + (cents / 100).toFixed(2);
      return str.replace(".00", "");
    }

    function updateDisplay() {
      qtyDisplays.forEach((d) => (d.textContent = currentQty));
      if (otpPriceDisplay)
        otpPriceDisplay.textContent = formatMoney(singlePrice * currentQty);
      if (subPriceDisplay)
        subPriceDisplay.textContent = formatMoney(singleSubPrice * currentQty);
      if (subCompPriceDisplay)
        subCompPriceDisplay.textContent = formatMoney(singlePrice * currentQty);
    }

    updateDisplay();

    increaseBtns.forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        currentQty++;
        updateDisplay();
      });
    });

    decreaseBtns.forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        if (currentQty > 1) {
          currentQty--;
          updateDisplay();
        }
      });
    });

    atbButtons.forEach((btn) => {
      btn.addEventListener("click", async (e) => {
        e.preventDefault();

        if (triggerElement) {
          if (isAddon) {
            // Calculate existing addons quantity in the cart
            let existingAddonQty = 0;
            document
              .querySelectorAll(".cart-template__addon-item")
              .forEach((addon) => {
                const qtyDisplay = addon.querySelector(
                  ".product-quantity, input[type='number']"
                );
                if (qtyDisplay) {
                  const val = parseInt(
                    qtyDisplay.textContent || qtyDisplay.value,
                    10
                  );
                  if (!isNaN(val)) existingAddonQty += val;
                }
              });

            if (existingAddonQty + currentQty > 4) {
              alert("You can only add a maximum of 4 one-off extras.");
              return;
            }

            const addonItem = triggerElement.closest(
              ".cart-template__addon-item"
            );
            if (addonItem) {
              const variantId = addonItem.dataset.variantId;
              if (variantId) {
                try {
                  const requestJson = {
                    items: [
                      {
                        id: parseInt(variantId, 10),
                        quantity: currentQty,
                      },
                    ],
                  };
                  await fetch("/cart/add.js", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(requestJson),
                  });
                  window.location.reload();
                } catch (error) {
                  console.error("Error adding to cart:", error);
                }
              }
            }
          } else {
            const card = triggerElement.closest(".custom-skio-dish-card");
            if (card) {
              const pageAddBtn =
                card.querySelector(
                  "button[aria-label*='Add'], button[aria-label*='add'], .product-quantity__increase"
                ) ||
                Array.from(card.querySelectorAll("button")).find(
                  (b) =>
                    b.textContent &&
                    (b.textContent.includes("Add") ||
                      b.textContent.includes("+"))
                );
              if (pageAddBtn) {
                for (let i = 0; i < currentQty; i++) {
                  pageAddBtn.click();
                }
              }
            }
          }
        }

        let modal = document.getElementById("custom-product-modal");
        if (modal) {
          modal.style.display = "none";
          document.body.style.overflow = "";
        }
      });
    });
  }
};

// ─── Cart Addon Product Detail Popup ─────────────────────────────────────────
(function () {
  var currentImages = [];
  var currentIndex = 0;

  // ── DOM helpers ──────────────────────────────────────────────────────────
  function el(id) {
    return document.getElementById(id);
  }

  // ── Navigate to a specific image index ───────────────────────────────────
  function goTo(index) {
    if (!currentImages.length) return;
    currentIndex = (index + currentImages.length) % currentImages.length;

    var imgEl = el("cart-addon-popup-image");
    if (imgEl) {
      imgEl.src = currentImages[currentIndex];
    }

    // Update thumbnail active state
    var thumbs = el("cart-addon-popup-thumbs");
    if (thumbs) {
      Array.prototype.forEach.call(
        thumbs.querySelectorAll(".addon-popup-thumb"),
        function (t, i) {
          t.style.borderColor =
            i === currentIndex
              ? "rgba(239,125,0,0.7)" // active – amber
              : "rgba(35,35,35,0.10)"; // inactive – primary-border
        }
      );
    }
  }

  // ── Close popup ────────────────────────────────────────────────────────────
  function closeAddonPopup() {
    var popup = el("cart-addon-detail-popup");
    if (!popup) return;
    popup.style.display = "none";
    document.body.style.overflow = "";
    currentImages = [];
    currentIndex = 0;
  }

  // ── Click delegation ───────────────────────────────────────────────────────
  document.addEventListener("click", function (e) {
    // Open on image-button click
    var trigger = e.target.closest(".cart-addon-image-trigger");
    if (trigger) {
      return;
    }

    // Prev arrow
    if (e.target.closest("#cart-addon-popup-prev")) {
      goTo(currentIndex - 1);
      return;
    }

    // Next arrow
    if (e.target.closest("#cart-addon-popup-next")) {
      goTo(currentIndex + 1);
      return;
    }

    // Close button
    if (e.target.closest("#cart-addon-popup-close")) {
      closeAddonPopup();
      return;
    }

    // Backdrop
    var popup = el("cart-addon-detail-popup");
    if (
      popup &&
      (e.target === popup || e.target.id === "cart-addon-popup-bg")
    ) {
      closeAddonPopup();
    }
  });

  // ── Keyboard: Escape closes, ← / → navigates ──────────────────────────────
  document.addEventListener("keydown", function (e) {
    var popup = el("cart-addon-detail-popup");
    if (!popup || popup.style.display === "none") return;

    if (e.key === "Escape") {
      closeAddonPopup();
    }
    if (e.key === "ArrowLeft") {
      goTo(currentIndex - 1);
    }
    if (e.key === "ArrowRight") {
      goTo(currentIndex + 1);
    }
  });
})();
/* ---- Delivery Countdown Banner ---- */
(function () {
  function initDeliveryCountdownBanner() {
    try {
      var bannerEl = document.getElementById("eq-delivery-countdown-banner");
      if (!bannerEl) return;

      var enabled = bannerEl.getAttribute("data-enabled") === "true";
      if (!enabled) return;

      var ukTodayStr = bannerEl.getAttribute("data-uk-today");
      var ukHour = parseInt(bannerEl.getAttribute("data-uk-hour"), 10) || 0;
      var ukMinute = parseInt(bannerEl.getAttribute("data-uk-minute"), 10) || 0;
      var ukSecond = parseInt(bannerEl.getAttribute("data-uk-second"), 10) || 0;

      if (!ukTodayStr) return;

      var parts = ukTodayStr.split("-").map(Number);
      if (parts.length !== 3) return;

      var serverNowDate = new Date(
        parts[0],
        parts[1] - 1,
        parts[2],
        ukHour,
        ukMinute,
        ukSecond
      );
      var timeOffset = serverNowDate.getTime() - Date.now();

      var testMode = bannerEl.getAttribute("data-test-mode") === "true";
      var hideAfterCutoff =
        bannerEl.getAttribute("data-hide-after-cutoff") === "true";

      var textBeforeCutoff =
        bannerEl.getAttribute("data-text-before-cutoff") ||
        "Order within {countdown} for same-week delivery on {delivery_day}";
      var textAfterCutoff =
        bannerEl.getAttribute("data-text-after-cutoff") ||
        "Same-week delivery window closed. Next available delivery is {delivery_day}";

      var rules = window.BinaeryRulesData || {
        disabledWeekdays: [0, 1, 2, 6],
        disabledDates: [],
        disabledRanges: [],
        cutoffMode: "days",
        cutoffDays: 2,
        cutoffTime: "12:00",
      };

      var isSameWeekDeliveryAllowed = rules.cutoffMode === "days";

      function parseYMD(str) {
        if (!str) return null;
        var p = String(str).slice(0, 10).split("-");
        if (p.length !== 3) return null;
        var y = parseInt(p[0], 10);
        var m = parseInt(p[1], 10) - 1;
        var d = parseInt(p[2], 10);
        if (isNaN(y) || isNaN(m) || isNaN(d)) return null;
        return new Date(y, m, d);
      }

      function toISO(date) {
        var y = date.getFullYear();
        var m = String(date.getMonth() + 1).padStart(2, "0");
        var d = String(date.getDate()).padStart(2, "0");
        return y + "-" + m + "-" + d;
      }

      function isDeliveryDayValid(date, rules) {
        var y = date.getFullYear();
        var m = String(date.getMonth() + 1).padStart(2, "0");
        var d = String(date.getDate()).padStart(2, "0");
        var iso = y + "-" + m + "-" + d;

        if (iso < ukTodayStr) return false;

        // If same-week delivery is not allowed, block any dates in the current week
        if (rules.cutoffMode !== "days") {
          var todayD = parseYMD(ukTodayStr);
          if (todayD) {
            var dow = todayD.getDay();
            var daysUntilSunday = (7 - dow) % 7;
            var cutoffSunday = new Date(
              todayD.getFullYear(),
              todayD.getMonth(),
              todayD.getDate() + daysUntilSunday
            );
            var mondayAfterSunday = new Date(
              cutoffSunday.getFullYear(),
              cutoffSunday.getMonth(),
              cutoffSunday.getDate() + 1
            );
            var minSelectableISO = toISO(mondayAfterSunday);
            if (iso < minSelectableISO) {
              return false;
            }
          }
        }

        if (
          Array.isArray(rules.specialEnabledDates) &&
          rules.specialEnabledDates.indexOf(iso) !== -1
        ) {
          return true;
        }

        var dow = date.getDay();
        var disabledWeekdays = Array.isArray(rules.disabledWeekdays)
          ? rules.disabledWeekdays
          : [0, 1, 2, 6];
        if (disabledWeekdays.indexOf(dow) !== -1) {
          return false;
        }

        if (
          Array.isArray(rules.disabledDates) &&
          rules.disabledDates.indexOf(iso) !== -1
        ) {
          return false;
        }

        if (Array.isArray(rules.disabledRanges)) {
          for (var i = 0; i < rules.disabledRanges.length; i++) {
            var r = rules.disabledRanges[i];
            if (r && r.start && r.end) {
              if (iso >= r.start && iso <= r.end) {
                return false;
              }
            }
          }
        }

        return true;
      }

      var todayDate = new Date(serverNowDate);
      var dayOfWeek = todayDate.getDay();
      var diffToMonday =
        todayDate.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1);
      var monday = new Date(
        todayDate.getFullYear(),
        todayDate.getMonth(),
        diffToMonday
      );

      var validDeliveryDaysInCurrentWeek = [];
      if (isSameWeekDeliveryAllowed) {
        for (var i = 0; i < 7; i++) {
          var d = new Date(
            monday.getFullYear(),
            monday.getMonth(),
            monday.getDate() + i
          );
          if (isDeliveryDayValid(d, rules)) {
            validDeliveryDaysInCurrentWeek.push(d);
          }
        }
      }

      var cutoffDays = parseInt(rules.cutoffDays, 10);
      if (isNaN(cutoffDays)) cutoffDays = 2;

      var cutoffTimeParts = String(rules.cutoffTime || "12:00").split(":");
      var cutoffHour = parseInt(cutoffTimeParts[0], 10) || 0;
      var cutoffMinute = parseInt(cutoffTimeParts[1], 10) || 0;

      var targetCutoffDate = null;
      var targetDeliveryDay = null;

      var currentUKDate = new Date(Date.now() + timeOffset);

      for (var i = 0; i < validDeliveryDaysInCurrentWeek.length; i++) {
        var deliveryDay = validDeliveryDaysInCurrentWeek[i];
        var cutoffDate = new Date(
          deliveryDay.getFullYear(),
          deliveryDay.getMonth(),
          deliveryDay.getDate() - cutoffDays,
          cutoffHour,
          cutoffMinute,
          0
        );

        if (currentUKDate < cutoffDate) {
          targetCutoffDate = cutoffDate;
          targetDeliveryDay = deliveryDay;
          break;
        }
      }

      if (testMode) {
        var testCutoffDate = new Date(currentUKDate);
        testCutoffDate.setDate(testCutoffDate.getDate() + 2);
        testCutoffDate.setHours(15, 0, 0, 0);

        targetCutoffDate = testCutoffDate;
        targetDeliveryDay = new Date(testCutoffDate);
        targetDeliveryDay.setDate(targetDeliveryDay.getDate() + cutoffDays);
      }

      var daysOfWeekNames = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ];
      var monthsNames = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];

      function getOrdinalSuffix(day) {
        if (day > 3 && day < 21) return "th";
        switch (day % 10) {
          case 1:
            return "st";
          case 2:
            return "nd";
          case 3:
            return "rd";
          default:
            return "th";
        }
      }

      function formatDeliveryDate(date) {
        var dayName = daysOfWeekNames[date.getDay()];
        var monthName = monthsNames[date.getMonth()];
        var dayNum = date.getDate();
        return (
          dayName + ", " + monthName + " " + dayNum + getOrdinalSuffix(dayNum)
        );
      }

      var nextAvailableDeliveryDay = null;

      // Computed lazily (not just once at page load) so that if the cutoff time
      // passes while the tab is left open without a refresh, the "after cutoff"
      // message can still resolve a real date instead of falling back to the
      // generic "the next available slot" text.
      function computeNextAvailableDeliveryDay(fromDate) {
        var searchStart = new Date(fromDate);
        searchStart.setDate(searchStart.getDate() + 1);
        for (var i = 0; i < 30; i++) {
          var testDate = new Date(
            searchStart.getFullYear(),
            searchStart.getMonth(),
            searchStart.getDate() + i
          );
          if (isDeliveryDayValid(testDate, rules)) {
            var testCutoffDate = new Date(
              testDate.getFullYear(),
              testDate.getMonth(),
              testDate.getDate() - cutoffDays,
              cutoffHour,
              cutoffMinute,
              0
            );
            if (fromDate < testCutoffDate) {
              return testDate;
            }
          }
        }
        return null;
      }

      function updateTimer() {
        try {
          var nowUK = new Date(Date.now() + timeOffset);

          if (targetCutoffDate && nowUK < targetCutoffDate) {
            var diffMs = targetCutoffDate.getTime() - nowUK.getTime();

            var totalSec = Math.floor(diffMs / 1000);
            var days = Math.floor(totalSec / 86400);
            var hrs = Math.floor((totalSec % 86400) / 3600);
            var mins = Math.floor((totalSec % 3600) / 60);
            var secs = totalSec % 60;

            var daysStr = String(days).padStart(2, "0");
            var hrsStr = String(hrs).padStart(2, "0");
            var minsStr = String(mins).padStart(2, "0");
            var secsStr = String(secs).padStart(2, "0");

            var countdownHTML =
              '<span class="eq-delivery-countdown-timer-pill" style="background-color: ' +
              (bannerEl.getAttribute("data-timer-bg") || "#212121") +
              "; color: " +
              (bannerEl.getAttribute("data-timer-text") || "#ffffff") +
              ';">' +
              daysStr +
              '<span class="eq-delivery-countdown-timer-sep">:</span>' +
              hrsStr +
              '<span class="eq-delivery-countdown-timer-sep">:</span>' +
              minsStr +
              '<span class="eq-delivery-countdown-timer-sep">:</span>' +
              secsStr +
              "</span>";

            var formattedDelDay = formatDeliveryDate(targetDeliveryDay);

            var fullText = textBeforeCutoff
              .replace("{countdown}", countdownHTML)
              .replace(
                "{delivery_day}",
                "<strong>" + formattedDelDay + "</strong>"
              );

            bannerEl.innerHTML = "<div><span>" + fullText + "</span></div>";
            bannerEl.style.display = "flex";
          } else {
            if (hideAfterCutoff) {
              bannerEl.style.display = "none";
            } else {
              if (!nextAvailableDeliveryDay) {
                nextAvailableDeliveryDay =
                  computeNextAvailableDeliveryDay(nowUK);
              }
              var formattedNextDelDay = nextAvailableDeliveryDay
                ? formatDeliveryDate(nextAvailableDeliveryDay)
                : "the next available slot";
              var fullText = textAfterCutoff.replace(
                "{delivery_day}",
                "<strong>" + formattedNextDelDay + "</strong>"
              );

              bannerEl.innerHTML = "<div><span>" + fullText + "</span></div>";
              bannerEl.style.display = "flex";
            }
          }
        } catch (timerErr) {
          console.error("[DeliveryCountdown] Timer update error:", timerErr);
        }
      }

      updateTimer();
      setInterval(updateTimer, 1000);
    } catch (err) {
      console.error("[DeliveryCountdown] Initialization error:", err);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initDeliveryCountdownBanner);
  } else {
    initDeliveryCountdownBanner();
  }
})();

// ── Skio Portal: Remove "Order again" button from DOM ────────────────────────
(function () {
  function removeOrderAgainButtons() {
    try {
      // Re-evaluate current path per DOM mutation callback
      if (window.location.pathname !== "/a/account/orders") return;

      document
        .querySelectorAll('button[aria-label="Order again"]')
        .forEach(function (btn) {
          const wrapper = btn.parentElement;
          if (wrapper && wrapper.children.length === 1) {
            wrapper.remove();
          } else {
            btn.remove();
          }
        });
    } catch (err) {
      console.error('[OrderAgainCleanup] Error removing buttons:', err);
    }
  }

  // Initial execution check
  removeOrderAgainButtons();

  // Attach observer to catch dynamically rendered buttons
  const orderAgainObserver = new MutationObserver(removeOrderAgainButtons);
  orderAgainObserver.observe(document.body, { childList: true, subtree: true });

  // Deterministic cleanup handle
  window._cleanupOrderAgainObserver = function () {
    if (orderAgainObserver) orderAgainObserver.disconnect();
  };
})();
